var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSaas = function SvgSaas(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 15.68425,
    x2: 86,
    y2: 157.675629,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 145.125,
    y1: 21.5,
    x2: 145.125,
    y2: 32.303749,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 126.3125,
    y1: 61.8125,
    x2: 126.3125,
    y2: 72.616249,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 67.1875,
    y1: 40.3125,
    x2: 67.1875,
    y2: 51.116249,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 104.8125,
    y1: 115.5625,
    x2: 104.8125,
    y2: 126.366249,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 51.0625,
    y1: 99.4375,
    x2: 51.0625,
    y2: 110.241249,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 26.875,
    y1: 139.75,
    x2: 26.875,
    y2: 150.553757,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9354226"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 42.1875 4.6875 C 40.464844 4.6875 39.0625 6.089844 39.0625 7.8125 C 39.0625 8.78125 39.515625 9.636719 40.207031 10.210938 L 37.289062 16.464844 C 37.101562 16.429688 36.914062 16.40625 36.71875 16.40625 C 35.652344 16.40625 34.710938 16.945312 34.144531 17.765625 L 22.625 13.574219 C 22.636719 13.476562 22.65625 13.382812 22.65625 13.28125 C 22.65625 11.558594 21.253906 10.15625 19.53125 10.15625 C 17.808594 10.15625 16.40625 11.558594 16.40625 13.28125 C 16.40625 15.003906 17.808594 16.40625 19.53125 16.40625 C 19.753906 16.40625 19.972656 16.378906 20.183594 16.335938 L 28.421875 32.8125 C 28.183594 33.023438 27.972656 33.265625 27.804688 33.542969 L 17.957031 30.585938 C 17.957031 30.546875 17.96875 30.507812 17.96875 30.46875 C 17.96875 28.746094 16.566406 27.34375 14.84375 27.34375 C 13.121094 27.34375 11.71875 28.746094 11.71875 30.46875 C 11.71875 31.320312 12.0625 32.09375 12.621094 32.660156 L 8.691406 39.203125 C 8.410156 39.121094 8.121094 39.0625 7.8125 39.0625 C 6.089844 39.0625 4.6875 40.464844 4.6875 42.1875 C 4.6875 43.910156 6.089844 45.3125 7.8125 45.3125 C 9.535156 45.3125 10.9375 43.910156 10.9375 42.1875 C 10.9375 41.335938 10.59375 40.5625 10.039062 40 L 13.964844 33.453125 C 14.246094 33.535156 14.535156 33.59375 14.84375 33.59375 C 15.972656 33.59375 16.957031 32.984375 17.507812 32.082031 L 27.355469 35.039062 C 27.355469 35.078125 27.34375 35.117188 27.34375 35.15625 C 27.34375 36.878906 28.746094 38.28125 30.46875 38.28125 C 32.191406 38.28125 33.59375 36.878906 33.59375 35.15625 C 33.59375 33.433594 32.191406 32.03125 30.46875 32.03125 C 30.246094 32.03125 30.027344 32.058594 29.816406 32.101562 L 21.578125 15.625 C 21.773438 15.453125 21.957031 15.265625 22.105469 15.046875 L 33.625 19.238281 C 33.613281 19.335938 33.59375 19.429688 33.59375 19.53125 C 33.59375 21.253906 34.996094 22.65625 36.71875 22.65625 C 38.441406 22.65625 39.84375 21.253906 39.84375 19.53125 C 39.84375 18.5625 39.390625 17.707031 38.699219 17.132812 L 41.617188 10.878906 C 41.804688 10.914062 41.992188 10.9375 42.1875 10.9375 C 43.910156 10.9375 45.3125 9.535156 45.3125 7.8125 C 45.3125 6.089844 43.910156 4.6875 42.1875 4.6875 Z M 42.1875 4.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 42.1875 6.25 C 41.324219 6.25 40.625 6.949219 40.625 7.8125 C 40.625 8.675781 41.324219 9.375 42.1875 9.375 C 43.050781 9.375 43.75 8.675781 43.75 7.8125 C 43.75 6.949219 43.050781 6.25 42.1875 6.25 Z M 42.1875 6.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 36.71875 17.96875 C 35.855469 17.96875 35.15625 18.667969 35.15625 19.53125 C 35.15625 20.394531 35.855469 21.09375 36.71875 21.09375 C 37.582031 21.09375 38.28125 20.394531 38.28125 19.53125 C 38.28125 18.667969 37.582031 17.96875 36.71875 17.96875 Z M 36.71875 17.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 19.53125 11.71875 C 18.667969 11.71875 17.96875 12.417969 17.96875 13.28125 C 17.96875 14.144531 18.667969 14.84375 19.53125 14.84375 C 20.394531 14.84375 21.09375 14.144531 21.09375 13.28125 C 21.09375 12.417969 20.394531 11.71875 19.53125 11.71875 Z M 19.53125 11.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 30.46875 33.59375 C 29.605469 33.59375 28.90625 34.292969 28.90625 35.15625 C 28.90625 36.019531 29.605469 36.71875 30.46875 36.71875 C 31.332031 36.71875 32.03125 36.019531 32.03125 35.15625 C 32.03125 34.292969 31.332031 33.59375 30.46875 33.59375 Z M 30.46875 33.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 14.84375 28.90625 C 13.980469 28.90625 13.28125 29.605469 13.28125 30.46875 C 13.28125 31.332031 13.980469 32.03125 14.84375 32.03125 C 15.707031 32.03125 16.40625 31.332031 16.40625 30.46875 C 16.40625 29.605469 15.707031 28.90625 14.84375 28.90625 Z M 14.84375 28.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 7.8125 40.625 C 6.949219 40.625 6.25 41.324219 6.25 42.1875 C 6.25 43.050781 6.949219 43.75 7.8125 43.75 C 8.675781 43.75 9.375 43.050781 9.375 42.1875 C 9.375 41.324219 8.675781 40.625 7.8125 40.625 Z M 7.8125 40.625 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSaas, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/saas.a1f9fcc9.svg";
export { ForwardRef as ReactComponent };